"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressCircle = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../");
var ProgressCircle = function (_a) {
    var className = _a.className, _b = _a.progress, progress = _b === void 0 ? 0 : _b, color = _a.color, children = _a.children, props = __rest(_a, ["className", "progress", "color", "children"]);
    var ProgressCircleClasses = classnames_1.default('ProgressCircle', className, {
        'ProgressCircle--blue': color === 'blue',
        'ProgressCircle--green': color === 'green',
        'ProgressCircle--red': color === 'red',
        'ProgressCircle--yellow': color === 'yellow',
    });
    function value_limit(val, min, max) {
        return val < min ? min : val > max ? max : val;
    }
    var thickness = 10;
    var radius = 50 - thickness / 2;
    var circumference = radius * 2 * Math.PI;
    var _c = react_1.default.useState(circumference), dashoffset = _c[0], setDashoffset = _c[1];
    react_1.default.useEffect(function () {
        setDashoffset(circumference -
            (value_limit(progress, 0, 100) / 100) * circumference);
    }, [circumference, progress]);
    var ProgressCircleComponent = (react_1.default.createElement("div", __assign({ className: ProgressCircleClasses }, props),
        react_1.default.createElement("svg", { className: "ProgressCircle__svg", viewBox: "0 0 100 100", xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("circle", { className: "ProgressCircle__background", strokeDasharray: circumference + " " + circumference, cx: "50", cy: "50", strokeWidth: thickness, r: radius }),
            react_1.default.createElement("circle", { className: "ProgressCircle__circle", style: { strokeDashoffset: dashoffset }, strokeDasharray: circumference + " " + circumference, cx: "50", cy: "50", strokeWidth: thickness, r: radius })),
        react_1.default.createElement(__1.Headline, { className: "ProgressCircle__children" }, children)));
    return ProgressCircleComponent;
};
exports.ProgressCircle = ProgressCircle;
//# sourceMappingURL=ProgressCircle.js.map